import { VerticalSegment } from 'components/verticalSegment'
import { AnswerButtons } from 'components/answerButtons'
import React, { useContext } from 'react'
import { AnswerPayload } from './actions'
import { QuestionState } from './reducer'
import './styles.scss'
import { LocaleContext } from '../../contexts/locale'
import { SubmissionStatus } from 'types/submissionStatus'
import { ArticleList } from 'components/articleList'

interface QuestionsProps {
  selectedAnswers: QuestionState
  submissionStatus: SubmissionStatus
}

interface QuestionsHandler {
  selectAnswer: (answer: AnswerPayload) => void
  guessVictims: (guess: number) => void
}

export const Questions = ({
  selectedAnswers,
  selectAnswer,
  guessVictims,
  submissionStatus
}: QuestionsProps & QuestionsHandler) => {
  if (submissionStatus === 'delivered') return null

  const locale = useContext(LocaleContext)
  const questions = require('locales/questions.' + locale + '.yml')
  const messages = require('./locales/' + locale + '.yml')

  return (
    <VerticalSegment className='questions'>
      <div className='ui inverted vertically divided grid'>
        {questions.map(q => {
          const sizes =
            q.id === 'dragons' ? '(min-width: 600px) 100vw, 140vw' : '300px'
          const image = require('images/questions/' +
            q.id +
            '.png?sizes=300w+600w+800w+1200w+1600w')

          return (
            <React.Fragment key={q.id}>
              <div
                className='stackable row middle aligned two column question'
                id={q.id}
              >
                <div className='column image'>
                  <img
                    src={image.sources['600w']}
                    srcSet={image.srcSet}
                    sizes={sizes}
                    alt=''
                    className='ui centered medium image'
                  />
                </div>
                <div className='column content'>
                  <h3 className='ui inverted small infographic header'>
                    <span>{q.question}</span>
                    <div
                      className='sub header'
                      dangerouslySetInnerHTML={{ __html: q.pointsDescription }}
                    />
                  </h3>
                  <div className='ui center aligned vertical very fitted segment'>
                    <AnswerButtons
                      handleAnswer={(clickedAnswer: string) => {
                        selectAnswer({
                          clickedAnswer: clickedAnswer,
                          questionId: q.id,
                          selectionType: q.selectionType
                        })
                      }}
                      responses={q.options}
                      className='basic fluid inverted'
                      selectionType={q.selectionType}
                      currentSelection={selectedAnswers[q.id] || undefined}
                    />
                  </div>
                </div>
              </div>

              {q.id === 'throne' && (
                <aside
                  key='articleList'
                  className='ui two column centered stackable row question'
                  id='aside'
                >
                  <div className='column'>
                    <ArticleList />
                  </div>
                </aside>
              )}
            </React.Fragment>
          )
        })}

        {/* Bonus Question */}
        <div className='ui two column centered stackable row question'>
          <div className='column content'>
            <h3 className='ui inverted small infographic header'>
              <span>{messages.guess.question}</span>
              <div className='sub header'>{messages.guess.description}</div>
            </h3>

            <div className='ui two column stackable centered grid'>
              <div className='column'>
                <div className='ui fluid inverted huge input'>
                  <input
                    type='number'
                    min={0}
                    value={
                      selectedAnswers['aryaVictims'] ||
                      selectedAnswers['aryaVictims'] === 0
                        ? selectedAnswers['aryaVictims']
                        : ''
                    }
                    onChange={event =>
                      guessVictims(parseInt(event.target.value, 10))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VerticalSegment>
  )
}
